import { render } from "./WhereBuy.vue?vue&type=template&id=1c3c36a0"
import script from "./WhereBuy.vue?vue&type=script&lang=js"
export * from "./WhereBuy.vue?vue&type=script&lang=js"

import "./WhereBuy.vue?vue&type=style&index=0&id=1c3c36a0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__